module.exports = __webpack_public_path__ + "img/10_Instaöllation-Preis.f3bff4b6.svg";